import { render, staticRenderFns } from "./body-employees.vue?vue&type=template&id=183f1c19&scoped=true"
import script from "./body-employees.vue?vue&type=script&lang=js"
export * from "./body-employees.vue?vue&type=script&lang=js"
import style0 from "./body-employees.vue?vue&type=style&index=0&id=183f1c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f1c19",
  null
  
)

export default component.exports